import React from "react"

const SVG = ({
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 32 32'
}) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      fill={fill}
      d='M16 0c8.835 0 16 7.166 16 16.001s-7.165 15.999-16 15.999-16-7.164-16-15.999c0-8.835 7.165-16.001 16-16.001zM14.747 26.857h2.501v-1.889h0.322c1.507-0.068 2.704-0.274 3.585-0.621 0.88-0.35 1.53-0.923 1.942-1.722 0.418-0.793 0.627-1.897 0.627-3.3 0-1.375-0.288-2.416-0.864-3.119s-1.327-1.169-2.258-1.386c-0.875-0.209-1.993-0.342-3.354-0.398v-4.898h0.492c0.897 0 1.529 0.153 1.908 0.457s0.571 0.889 0.571 1.758c0 0.144 0.005 0.263 0.023 0.361h3.026c0-1.487-0.225-2.605-0.683-3.342-0.457-0.745-1.117-1.237-1.975-1.482-0.813-0.234-1.931-0.384-3.36-0.457v-1.676h-2.501v1.666c-1.276 0.017-2.354 0.144-3.229 0.384-0.937 0.254-1.682 0.751-2.219 1.49-0.537 0.734-0.808 1.787-0.808 3.156 0 1.11 0.153 1.999 0.458 2.667 0.31 0.664 0.75 1.163 1.315 1.496 0.57 0.336 1.202 0.562 1.908 0.68 0.649 0.11 1.507 0.203 2.574 0.279v5.32c-0.763-0.050-1.304-0.096-1.62-0.141-0.356-0.051-0.678-0.172-0.954-0.366s-0.48-0.5-0.61-0.918c-0.124-0.424-0.186-1.016-0.186-1.801h-3.1l0.023 0.644c0 1.033 0.164 1.899 0.492 2.597 0.327 0.691 0.79 1.233 1.383 1.62 0.593 0.389 1.293 0.657 2.1 0.816 0.734 0.141 1.559 0.22 2.473 0.234v1.889zM14.747 9.526v4.816c-1.016-0.028-1.778-0.209-2.304-0.542-0.57-0.364-0.852-1.031-0.852-2.010 0-0.683 0.119-1.183 0.356-1.504 0.237-0.316 0.559-0.525 0.96-0.613 0.406-0.090 0.949-0.138 1.637-0.147h0.204zM17.248 22.301v-5.295c0.83 0.073 1.445 0.152 1.846 0.245 0.446 0.099 0.808 0.334 1.084 0.7 0.283 0.37 0.424 0.943 0.424 1.728 0 0.999-0.248 1.69-0.745 2.060-0.497 0.373-1.259 0.562-2.287 0.562h-0.322z'
    />
  </svg>
)

export default SVG